import {CONSULTATION_KEY_TYPE, CONSULTATION_TARGET_KEY_TYPE} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	managerId: z.string(), // 담당자 - 자동입력
	taxAccountantId: z.string(), // 세무사
	visitedAt: z.string(), // 면담일시 - YYYY-MM-dd HH:mm
	wroteDate: z.string(), // 작성일자 - 자동입력
	visitPurpose: CONSULTATION_KEY_TYPE.nullable(), // 유형
	visitPurposeDetail: CONSULTATION_TARGET_KEY_TYPE.nullable(), // 구분
	content: z.string().nullable(),
	recommendedTaxAccountantId: z.string().nullable(), // 추천 세무사 - 추천이 있는 경우
	recommendedCustomerIds: z.array(z.string()).nullable(), // 추천 고객
	files: z.array(z.string()).nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const VisitHistoryCreateModel = {schema, model};
export type IVisitHistoryCreateModel = z.infer<typeof VisitHistoryCreateModel.model>;

export const DEFAULT_VISIT_HISTORY_CREATE: IVisitHistoryCreateModel = {
	managerId: "",
	taxAccountantId: "",
	visitedAt: "",
	wroteDate: "",
	visitPurpose: null,
	visitPurposeDetail: null,
	content: "",
	recommendedTaxAccountantId: null,
	recommendedCustomerIds: [],
	files: []
};
